// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../images/botnay.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subjectvideo_modal {
  position: relative;
}
.subjectvideo_modal .w-30 {
  width: 30% !important;
}
.subjectvideo_modal.chapter_modal .modal-header {
  background: #f1f3f5;
  box-shadow: 0px -10px 20px rgba(0, 0, 0, 0.1607843137);
}
.subjectvideo_modal.chapter_modal .modal-header::before {
  display: none;
}
.subjectvideo_modal .modal-content {
  overflow: hidden;
  border: none;
  border-radius: 10px;
}
.subjectvideo_modal .modal-content .modal-header {
  position: relative;
}
.subjectvideo_modal .modal-content .modal-header .buysubjectvideomodal {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: absolute;
  z-index: 1;
  backdrop-filter: blur(17px);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
}
.subjectvideo_modal .modal-content .modal-header::before {
  background: linear-gradient(to top, transparent -34%, #679B31 50%);
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: absolute;
  z-index: 2;
}
.subjectvideo_modal .modal-content .modal-header .title-content {
  color: #ffffff;
  position: relative;
  z-index: 3;
}
.subjectvideo_modal .modal-content .modal-body .select-class .price {
  font-size: 12px;
  color: #d3d3d3;
}
.subjectvideo_modal .modal-content .modal-body .select-class li {
  margin-bottom: 0.1rem;
  padding: 0.4rem;
  border: 1px solid transparent;
}
.subjectvideo_modal .modal-content .modal-body .select-class li:last-child {
  margin-bottom: 0;
}
.subjectvideo_modal .modal-content .modal-body .select-class li i {
  opacity: 0;
}
.subjectvideo_modal .modal-content .modal-body .select-class li.active {
  border: 1px solid #212C63;
  border-radius: 5px;
  padding: 0.4rem;
}
.subjectvideo_modal .modal-content .modal-body .select-class li.active i {
  opacity: 1;
  color: #03912e;
}
.subjectvideo_modal .modal-content .modal-body .total-count-list li {
  margin-bottom: 1rem;
}
.subjectvideo_modal .modal-content .modal-body .total-count-list li:last-child {
  margin-bottom: 0;
}
.subjectvideo_modal .modal-content .modal-body .card {
  background: rgba(33, 44, 99, 0.0784313725) 0% 0% no-repeat padding-box;
  border: 1px solid #212C63;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/learn_practice/subjects/_subjectvideomodal.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,qBAAA;AACR;AAEI;EACI,mBAAA;EACA,sDAAA;AAAR;AAEQ;EACI,aAAA;AAAZ;AAII;EACI,gBAAA;EACA,YAAA;EACA,mBAAA;AAFR;AAIQ;EACI,kBAAA;AAFZ;AAIY;EACI,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;EACA,mDAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AAFhB;AAKY;EACI,kEAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AAHhB;AAMY;EACI,cAAA;EACA,kBAAA;EACA,UAAA;AAJhB;AAUgB;EACI,eAAA;EACA,cAAA;AARpB;AAWgB;EACI,qBAAA;EACA,eAAA;EACA,6BAAA;AATpB;AAWoB;EACI,gBAAA;AATxB;AAYoB;EACI,UAAA;AAVxB;AAaoB;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;AAXxB;AAawB;EACI,UAAA;EACA,cAAA;AAX5B;AAiBY;EACI,mBAAA;AAfhB;AAiBgB;EACI,gBAAA;AAfpB;AAmBY;EACI,sEAAA;EACA,yBAAA;EACA,mBAAA;AAjBhB","sourcesContent":[".subjectvideo_modal {\n    position: relative;\n\n    .w-30 {\n        width: 30% !important;\n    }\n\n    &.chapter_modal .modal-header {\n        background: #f1f3f5;\n        box-shadow: 0px -10px 20px #00000029;\n\n        &::before {\n            display: none;\n        }\n    }\n\n    .modal-content {\n        overflow: hidden;\n        border: none;\n        border-radius: 10px;\n\n        .modal-header {\n            position: relative;\n\n            .buysubjectvideomodal {\n                left: 0;\n                top: 0;\n                width: 100%;\n                height: 100%;\n                content: '';\n                position: absolute;\n                z-index: 1;\n                backdrop-filter: blur(17px);\n                background: url('../../../../images/botnay.png');\n                background-size: cover;\n                background-position: bottom center;\n                background-repeat: no-repeat;\n            }\n\n            &::before {\n                background: linear-gradient(to top, transparent -34%, #679B31 50%);\n                left: 0;\n                top: 0;\n                width: 100%;\n                height: 100%;\n                content: '';\n                position: absolute;\n                z-index: 2;\n            }\n\n            .title-content {\n                color: #ffffff;\n                position: relative;\n                z-index: 3;\n            }\n        }\n\n        .modal-body {\n            .select-class {\n                .price {\n                    font-size: 12px;\n                    color: #d3d3d3;\n                }\n\n                li {\n                    margin-bottom: 0.1rem;\n                    padding: 0.4rem;\n                    border: 1px solid transparent;\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n\n                    i {\n                        opacity: 0;\n                    }\n\n                    &.active {\n                        border: 1px solid #212C63;\n                        border-radius: 5px;\n                        padding: 0.4rem;\n\n                        i {\n                            opacity: 1;\n                            color: #03912e;\n                        }\n                    }\n                }\n            }\n\n            .total-count-list li {\n                margin-bottom: 1rem;\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n\n            .card {\n                background: #212C6314 0% 0% no-repeat padding-box;\n                border: 1px solid #212C63;\n                border-radius: 10px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
